module.exports = __webpack_public_path__ + "static/datenschutz-a2edbbb9e7ff91266cf56049850d569f.jpg";